<template>
  <div class="apply-add-form">
    <gtable-crud
      ref="gtable-crud"
      :search-form="searchQuery"
      :data="leaveHistory"
      :option="option"
      :page="page"
      :loading="loading"
      @searchChange="searchChange"
      @pageChange="pageChange"
      @refresh-change="refreshChange"
    >
      <!-- <template
        slot="menuLeft"
        slot-scope="{row}"
      >
        <template v-if="row.files.length">
          <my-tooltip :tooltip="$t(`_components.btns.edit`)">
            <feather-icon
              style="margin-left: 1rem"
              icon="ListIcon"
              size="20"
              class="cursor-pointer text-warning"
              @click="handleViewList(row)"
            />
          </my-tooltip>
        </template>
      </template> -->
    </gtable-crud>
  </div>
</template>

<script>
import { viewLeaveHistory, leaverecordList, viewLeaveHistoryByWorker } from '@/api/worker/vacation'

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      leaveHistory: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 10,
      },
      loading: false,

    }
  },
  computed: {
    option() {
      const columns = [
        {
          label: this.i18n('labelEmployment.staffNo'),
          field: 'staffNo',
        },
        {
          label: this.$t('_worker.label.name'),
          field: 'staffName',
        },
        {
          label: this.i18n('labelLeaverecord.vacationInfoId'),
          field: 'vacationInfoId',
          dictField: 'vacationName',
          type: 'select',
          dictCode: 'vacationInfo',
          search: true,
          searchBase: true,
          formOption: {
            rules: 'required',
            type: 'select',
            dictCode: 'vacationInfo',
          },
        },
        {
          label: this.i18n('labelLeaverecord.leaveDays'),
          field: 'leaveDays',
          formOption: {
            rules: 'required',
            type: 'number',
          },
        },
        {
          label: this.i18n('labelLeaverecord.leaveStartTime'),
          field: 'leaveStartTime',
          type: 'dateTime',
          dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
            type: 'dateTime',
          },
        },
        {
          label: this.i18n('labelLeaverecord.leaveEndTime'),
          field: 'leaveEndTime',
          type: 'dateTime',
          dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
            type: 'dateTime',
          },
        },
      ]
      const workerCols = [
        {
          label: this.$t('_worker.label.employmentCode'),
          field: 'code',
        },
        {
          label: this.$t('_worker.label.name'),
          field: 'name',
        },
        {
          label: this.i18n('labelLeaverecord.vacationInfoId'),
          field: 'vacationInfoId',
          dictField: 'vacationName',
          type: 'select',
          dictCode: 'workerVacationInfo',
          search: true,
          searchBase: true,
          formOption: {
            rules: 'required',
            type: 'select',
            dictCode: 'vacationInfo',
          },
        },
        {
          label: this.i18n('labelLeaverecord.leaveDays'),
          field: 'leaveDays',
          formOption: {
            rules: 'required',
            type: 'number',
          },
        },
        {
          label: this.i18n('labelLeaverecord.leaveStartTime'),
          field: 'leaveStartTime',
          type: 'dateTime',
          dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
            type: 'dateTime',
          },
        },
        {
          label: this.i18n('labelLeaverecord.leaveEndTime'),
          field: 'leaveEndTime',
          type: 'dateTime',
          dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
          dateOutputFormat: 'MMM do yy',
          formOption: {
            rules: 'required',
            type: 'dateTime',
          },
        },
      ]
      const option = {
        header: true,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        isEnterSearch: true,
        batchDelBtn: false, // 批量删除按钮(默认 false)
        uploadBtn: false,
        downloadBtn: false,
        refreshBtn: false,
        search: true,
        isPagination: false,
        columnOption: false,
        menu: false, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form
        searchVisible: false, // 搜索默认展开
        fixedHeader: true, // 固定表头
        lineNumbers: false, // 显示每行数据的下标
        selection: false, // 复选框
        searchSpan: 4,
        columns: this.userInfo.staffId ? columns : workerCols,
      }
      return option
    },
  },
  mounted() {
    this.getLeaveHistoryList(this.page)
  },
  methods: {
    // viewLeaveHistory
    getLeaveHistoryList(page, params = {}) {
      this.loading = true
      if (this.userInfo.workerId) {
        viewLeaveHistoryByWorker(page.currentPage, page.pageSize, { ...params, workerId: this.userInfo.workerId }).then(res => {
          const { leaveRecords } = res.data.data
          this.leaveHistory = leaveRecords
          this.page.total = res.data.data.total
          this.loading = false
        })
      }
      if (this.userInfo.staffId) {
        viewLeaveHistory(page.currentPage, page.pageSize, { ...params, staffId: this.userInfo.staffId }).then(res => {
          const { records } = res.data.data
          this.leaveHistory = records
          this.page.total = res.data.data.total
          this.loading = false
        })
      }
    },
    searchChange(done, e) {
      this.query = e
      this.getLeaveHistoryList(this.page, e)
      done();
    },
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    pageChange() {

    },
  },
}
</script>

<style lang='scss' scoped>
.apply-add-form{
    &-line{
        width: 100%;
        border-bottom: 1px solid #CAD6EB;
    }
    &__share{
      position: absolute;
      top: -50px;
      right: 50px;
    }
}

</style>
